import React, { useState, useEffect, useCallback, useRef } from "react";
import SERVER_CONFIG from "../services/config";

const API_URL = SERVER_CONFIG.apiUrl;
const ADMIN_WEB = "https://zhylytaban.kz/admin";
function getToken() { return localStorage.getItem("token"); }
function authHeaders() { return { Authorization: `Bearer ${getToken()}` }; }

function RehomingPage({ user, channel }) {
  const [tab, setTab] = useState("greetings");
  const [query, setQuery] = useState("");
  const [adopted, setAdopted] = useState([]);
  const [selected, setSelected] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [calls, setCalls] = useState([]);
  const [comments, setComments] = useState({});
  const [busyCall, setBusyCall] = useState(null);
  const fileRef = useRef(null);

  const senderName = user?.display_name || user?.full_name || user?.username || "";

  const loadAdopted = useCallback(async (q) => {
    try {
      const res = await fetch(`${API_URL}/rehoming/adopted?q=${encodeURIComponent(q || "")}`, { headers: authHeaders() });
      setAdopted(await res.json());
    } catch (e) { console.error(e); }
  }, []);

  const loadCalls = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/rehoming/calls-today`, { headers: authHeaders() });
      setCalls(await res.json());
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => { loadAdopted(""); loadCalls(); }, [loadAdopted, loadCalls]);
  useEffect(() => { const t = setTimeout(() => loadAdopted(query), 300); return () => clearTimeout(t); }, [query, loadAdopted]);

  const onPickFiles = () => fileRef.current && fileRef.current.click();

  const onFilesChosen = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length || !selected) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("channelId", channel?.id);
      fd.append("content", `🏠 Привет: ${selected.animal_name} — ${selected.adopter_full_name}`);
      files.forEach(f => fd.append("files", f));
      const up = await fetch(`${API_URL}/files/upload`, { method: "POST", headers: authHeaders(), body: fd });
      if (!up.ok) throw new Error("upload failed");
      const upData = await up.json();
      const fileIds = (upData?.data?.files || []).map(f => f.id).filter(Boolean);
      if (fileIds.length) {
        await fetch(`${API_URL}/rehoming/attach-greeting`, {
          method: "POST",
          headers: { ...authHeaders(), "Content-Type": "application/json" },
          body: JSON.stringify({ adoptionId: selected.id, fileIds, sentBy: senderName }),
        });
      }
      alert("Привет отправлен и прикреплён к карточке ✅");
      loadAdopted(query);
    } catch (err) {
      alert("Ошибка загрузки: " + err.message);
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const submitCall = async (item, success) => {
    setBusyCall(item.id);
    try {
      await fetch(`${API_URL}/rehoming/calls/${item.id}`, {
        method: "POST",
        headers: { ...authHeaders(), "Content-Type": "application/json" },
        body: JSON.stringify({ success, comment: comments[item.id] || "", by: senderName }),
      });
      await loadCalls();
    } catch (e) { alert("Ошибка: " + e.message); }
    finally { setBusyCall(null); }
  };

  const S = {
    wrap: { padding: 14, maxWidth: 820, margin: "0 auto", height: "100%", overflowY: "auto" },
    tabs: { display: "flex", gap: 8, marginBottom: 14 },
    tabBtn: (a) => ({ padding: "8px 16px", borderRadius: 8, border: "1px solid #d0d7de", cursor: "pointer", background: a ? "#409eff" : "#fff", color: a ? "#fff" : "#333", fontWeight: 600 }),
    input: { width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #d0d7de", marginBottom: 12, boxSizing: "border-box" },
    card: (sel) => ({ display: "flex", gap: 10, alignItems: "center", padding: 10, border: `2px solid ${sel ? "#409eff" : "#ebeef5"}`, borderRadius: 10, marginBottom: 8, cursor: "pointer", background: sel ? "#ecf5ff" : "#fff" }),
    photo: { width: 48, height: 48, borderRadius: 8, objectFit: "cover", background: "#f0f2f5" },
    muted: { color: "#909399", fontSize: 13 },
    callCard: { border: "1px solid #ebeef5", borderRadius: 10, padding: 12, marginBottom: 10 },
    btnOk: { padding: "8px 14px", borderRadius: 8, border: "none", background: "#67c23a", color: "#fff", cursor: "pointer", fontWeight: 600 },
    btnFail: { padding: "8px 14px", borderRadius: 8, border: "none", background: "#f56c6c", color: "#fff", cursor: "pointer", fontWeight: 600 },
    ta: { width: "100%", padding: 8, borderRadius: 8, border: "1px solid #d0d7de", marginTop: 8, boxSizing: "border-box" },
  };

  return (
    <div style={S.wrap}>
      <div style={S.tabs}>
        <div style={S.tabBtn(tab === "greetings")} onClick={() => setTab("greetings")}>Фото/видео-приветы</div>
        <div style={S.tabBtn(tab === "calls")} onClick={() => { setTab("calls"); loadCalls(); }}>
          Звонки сегодня{calls.length ? ` (${calls.length})` : ""}
        </div>
      </div>

      {tab === "greetings" && (
        <div>
          <input style={S.input} placeholder="Поиск по кличке или ФИО получателя…"
                 value={query} onChange={e => setQuery(e.target.value)} />
          <input ref={fileRef} type="file" accept="image/*,video/*" multiple style={{ display: "none" }} onChange={onFilesChosen} />
          {adopted.length === 0 && <div style={S.muted}>Нет пристроенных животных.</div>}
          {adopted.map(a => (
            <div key={a.id} style={S.card(selected?.id === a.id)} onClick={() => setSelected(a)}>
              <img style={S.photo} src={a.photo ? `${ADMIN_WEB}${a.photo}` : ""} alt="" onError={e => { e.target.style.visibility = "hidden"; }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600 }}>{a.animal_name} <span style={S.muted}>({a.animal_type})</span></div>
                <div style={S.muted}>{a.adopter_full_name}{a.phone ? ` · ${a.phone}` : ""}</div>
                <div style={S.muted}>приветов: {a.greetings_count || 0}</div>
              </div>
              {selected?.id === a.id && (
                <button style={S.btnOk} disabled={uploading} onClick={(e) => { e.stopPropagation(); onPickFiles(); }}>
                  {uploading ? "Загрузка…" : "Загрузить фото/видео"}
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      {tab === "calls" && (
        <div>
          {calls.length === 0 && <div style={S.muted}>На сегодня звонков нет 🎉</div>}
          {calls.map(c => (
            <div key={c.id} style={S.callCard}>
              <div style={{ fontWeight: 600, fontSize: 16 }}>
                {c.adopter_full_name}
                {c.consecutive_failures >= 3 && <span style={{ marginLeft: 8, color: "#fff", background: "#f56c6c", padding: "2px 8px", borderRadius: 6, fontSize: 12 }}>{c.consecutive_failures} неудачи подряд — принять меры</span>}
                {c.consecutive_failures > 0 && c.consecutive_failures < 3 && <span style={{ marginLeft: 8, color: "#e6a23c", fontSize: 13 }}>неудач подряд: {c.consecutive_failures}</span>}
              </div>
              <div style={S.muted}>
                📞 <a href={`tel:${c.phone || ""}`}>{c.phone || "нет номера"}</a> · {c.animal_name} ({c.animal_type}) · пристроен {c.adoption_date}
              </div>
              <textarea style={S.ta} rows={2} placeholder="Комментарий по результату звонка…"
                        value={comments[c.id] || ""} onChange={e => setComments({ ...comments, [c.id]: e.target.value })} />
              <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                <button style={S.btnOk} disabled={busyCall === c.id} onClick={() => submitCall(c, true)}>✓ Дозвонились</button>
                <button style={S.btnFail} disabled={busyCall === c.id} onClick={() => submitCall(c, false)}>✗ Не дозвонились (на завтра)</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default RehomingPage;
